module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/alterar-senha/alterar-senha.component.scss
// module id = ./src/app/shared/componentes/alterar-senha/alterar-senha.component.scss
// module chunks = main